(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var LABELS = ['', 'Décevant', 'Moyen', 'Bien', 'Très bien', 'Parfait'];

  function stars(n) { var s = ''; for (var i = 1; i <= 5; i++) s += i <= n ? '★' : '☆'; return s; }
  function clampRating(r) { r = parseInt(r, 10); return isNaN(r) ? 5 : Math.min(5, Math.max(1, r)); }
  function initial(name) { name = (name || '').trim(); return name ? name.charAt(0).toUpperCase() : '♡'; }
  function el(tag, cls, text) { var n = document.createElement(tag); if (cls) n.className = cls; if (text != null) n.textContent = text; return n; }

  function init(root) {
    if (root.getAttribute('data-ready')) return;
    root.setAttribute('data-ready', '1');

    var API_URL = root.getAttribute('data-api-url');
    function q(sel) { return root.querySelector(sel); }

    var track = q('[data-reviews-track]');
    var loadingEl = q('[data-loading]');
    var emptyEl = q('[data-empty]');
    var avgNumEl = q('[data-avg-number]');
    var avgStarsEl = q('[data-avg-stars]');
    var countEl = q('[data-review-count]');
    var breakEl = q('[data-breakdown]');
    var prevBtn = q('[data-prev]');
    var nextBtn = q('[data-next]');
    var progressEl = q('[data-progress]');

    var overlay = q('[data-review-modal-overlay]');
    var openBtn = q('[data-open-review-modal]');
    var closeBtn = q('[data-close-review-modal]');
    var form = q('[data-review-form]');
    var fieldsEl = q('[data-form-fields]');
    var starPicker = q('[data-star-picker]');
    var ratingInput = q('[data-rating-input]');
    var rateLabel = q('[data-rate-label]');
    var nameInput = q('[data-name-input]');
    var textInput = q('[data-text-input]');
    var charCount = q('[data-char-count]');
    var errorEl = q('[data-review-error]');
    var successEl = q('[data-review-success]');
    var submitButton = q('[data-submit-button]');

    function makeCard(review, index) {
      var rating = clampRating(review.rating);
      var card = el('article', 'lr__card');
      card.style.setProperty('--n', Math.min(index, 8));
      card.insertAdjacentHTML('afterbegin', '<svg class="lr__quote" viewBox="0 0 24 24" aria-hidden="true"><path d="M9.5 6C6 7.4 4 10.3 4 14v4h6v-6H7.2c.2-2 1.3-3.4 3.3-4.2L9.5 6zm9 0c-3.5 1.4-5.5 4.3-5.5 8v4h6v-6h-2.8c.2-2 1.3-3.4 3.3-4.2L18.5 6z"/></svg>');
      var st = el('div', 'lr__stars', stars(rating));
      st.setAttribute('aria-label', rating + ' sur 5');
      var txt = el('p', 'lr__text', review.text);
      var more = el('button', 'lr__more', 'Lire la suite');
      more.type = 'button';
      more.hidden = true;
      more.addEventListener('click', function () {
        var open = card.classList.toggle('is-open');
        more.textContent = open ? 'Réduire' : 'Lire la suite';
      });
      var foot = el('div', 'lr__foot');
      var who = el('div', 'lr__who');
      who.appendChild(el('span', 'lr__name', review.name));
      if (review.date) who.appendChild(el('span', 'lr__date', review.date));
      foot.appendChild(el('div', 'lr__avatar', initial(review.name)));
      foot.appendChild(who);
      card.appendChild(st);
      card.appendChild(txt);
      card.appendChild(more);
      card.appendChild(foot);
      card._more = more;
      card._txt = txt;
      return card;
    }

    function checkClamps() {
      Array.prototype.forEach.call(track.children, function (card) {
        if (!card._txt || card.classList.contains('is-open')) return;
        card._more.hidden = !(card._txt.scrollHeight > card._txt.clientHeight + 2);
      });
    }

    function renderSummary(list) {
      var total = list.length, sum = 0, counts = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 };
      list.forEach(function (r) { var n = clampRating(r.rating); counts[n]++; sum += n; });
      var avg = total ? sum / total : 0;
      avgNumEl.textContent = total ? avg.toFixed(1).replace('.', ',') : '–';
      avgStarsEl.textContent = total ? stars(Math.round(avg)) : '☆☆☆☆☆';
      countEl.textContent = total === 1 ? '1 avis' : total + ' avis';
      breakEl.innerHTML = '';
      [5, 4, 3, 2, 1].forEach(function (s) {
        var pct = total ? Math.round((counts[s] / total) * 100) : 0;
        var row = el('div', 'lr-row');
        row.appendChild(el('span', null, s + ' ★'));
        var bar = el('span', 'lr-row__bar');
        var fill = el('span', 'lr-row__fill');
        bar.appendChild(fill);
        row.appendChild(bar);
        row.appendChild(el('span', null, String(counts[s])));
        breakEl.appendChild(row);
        requestAnimationFrame(function () { requestAnimationFrame(function () { fill.style.width = pct + '%'; }); });
      });
    }

    var userTouched = false, hovering = false, timer = null;

    function updateControls() {
      var max = track.scrollWidth - track.clientWidth;
      var ratio = track.scrollWidth ? (track.scrollLeft + track.clientWidth) / track.scrollWidth : 1;
      progressEl.style.transform = 'scaleX(' + Math.max(0.12, Math.min(1, ratio)) + ')';
      prevBtn.style.opacity = track.scrollLeft <= 4 ? '.4' : '1';
      nextBtn.style.opacity = track.scrollLeft >= max - 4 ? '.4' : '1';
    }
    function step(dir) {
      var card = track.firstElementChild;
      if (!card) return;
      var w = card.getBoundingClientRect().width + 18;
      var max = track.scrollWidth - track.clientWidth;
      if (dir > 0 && track.scrollLeft >= max - 6) { track.scrollTo({ left: 0 }); return; }
      track.scrollBy({ left: dir * w });
    }
    function touched() { userTouched = true; }
    prevBtn.addEventListener('click', function () { touched(); step(-1); });
    nextBtn.addEventListener('click', function () { touched(); step(1); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(updateControls); }, { passive: true });
    ['pointerdown', 'wheel', 'touchstart', 'keydown'].forEach(function (ev) { track.addEventListener(ev, touched, { passive: true }); });
    track.addEventListener('mouseenter', function () { hovering = true; });
    track.addEventListener('mouseleave', function () { hovering = false; });
    track.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') step(1); if (e.key === 'ArrowLeft') step(-1); });
    window.addEventListener('resize', function () { checkClamps(); updateControls(); });

    function startAuto() {
      if (reduce || timer) return;
      timer = setInterval(function () {
        if (document.hidden || hovering || userTouched || overlay.classList.contains('is-open')) return;
        var r = root.getBoundingClientRect();
        if (r.bottom < 0 || r.top > window.innerHeight) return;
        step(1);
      }, 6500);
    }

    async function loadReviews() {
      if (!API_URL) {
        loadingEl.classList.add('is-hidden');
        emptyEl.textContent = 'Les avis ne sont pas encore configurés.';
        emptyEl.hidden = false;
        return;
      }
      try {
        var response = await fetch(API_URL + '?action=getReviews&t=' + Date.now(), { method: 'GET', cache: 'no-store' });
        if (!response.ok) throw new Error('Erreur serveur');
        var data = await response.json();
        var list = (data && data.reviews) ? data.reviews : [];
        track.innerHTML = '';
        loadingEl.classList.add('is-hidden');
        if (!list.length) {
          emptyEl.hidden = false;
        } else {
          emptyEl.hidden = true;
          list.forEach(function (r, i) { track.appendChild(makeCard(r, i)); });
        }
        renderSummary(list);
        setTimeout(function () { checkClamps(); updateControls(); }, 60);
        startAuto();
      } catch (error) {
        console.error('Erreur chargement avis :', error);
        loadingEl.classList.add('is-hidden');
        emptyEl.textContent = 'Impossible de charger les avis pour le moment.';
        emptyEl.hidden = false;
      }
    }

    var lastFocus = null;
    function setStars(value) {
      ratingInput.value = value;
      Array.prototype.forEach.call(starPicker.querySelectorAll('button'), function (b) {
        b.classList.toggle('is-filled', parseInt(b.getAttribute('data-star-value'), 10) <= value);
      });
      rateLabel.textContent = LABELS[value] || '';
    }
    function openModal() {
      lastFocus = document.activeElement;
      overlay.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
      errorEl.classList.remove('is-visible');
      successEl.classList.remove('is-visible');
      fieldsEl.style.display = '';
      setTimeout(function () { nameInput.focus(); }, 80);
    }
    function closeModal() {
      overlay.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    openBtn.addEventListener('click', openModal);
    closeBtn.addEventListener('click', closeModal);
    overlay.addEventListener('click', function (e) { if (e.target === overlay) closeModal(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && overlay.classList.contains('is-open')) closeModal(); });

    Array.prototype.forEach.call(starPicker.querySelectorAll('button'), function (btn) {
      var v = parseInt(btn.getAttribute('data-star-value'), 10);
      btn.addEventListener('click', function () { setStars(v); });
      btn.addEventListener('mouseenter', function () {
        Array.prototype.forEach.call(starPicker.querySelectorAll('button'), function (b) {
          b.classList.toggle('is-filled', parseInt(b.getAttribute('data-star-value'), 10) <= v);
        });
        rateLabel.textContent = LABELS[v];
      });
    });
    starPicker.addEventListener('mouseleave', function () { setStars(clampRating(ratingInput.value)); });
    textInput.addEventListener('input', function () { charCount.textContent = textInput.value.length; });

    function showError(msg) { errorEl.textContent = msg; errorEl.classList.add('is-visible'); }

    form.addEventListener('submit', async function (event) {
      event.preventDefault();
      errorEl.classList.remove('is-visible');
      if (!API_URL) { showError('Le système d’avis n’est pas encore configuré.'); return; }
      var rating = parseInt(ratingInput.value, 10);
      var name = nameInput.value.trim();
      var text = textInput.value.trim();
      if (!rating || !name || !text) { showError('Merci de renseigner votre note, votre prénom et votre avis.'); return; }
      if (name.length > 50) { showError('Votre prénom est trop long.'); return; }
      if (text.length > 500) { showError('Votre avis est trop long.'); return; }

      submitButton.disabled = true;
      submitButton.textContent = 'Envoi en cours...';
      try {
        var response = await fetch(API_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'text/plain;charset=utf-8' },
          body: JSON.stringify({ action: 'addReview', rating: rating, name: name, text: text })
        });
        var result = await response.json();
        if (!result.success) throw new Error(result.message || 'Erreur lors de l’envoi.');
        fieldsEl.style.display = 'none';
        successEl.classList.add('is-visible');
        form.reset();
        charCount.textContent = '0';
        setStars(5);
        setTimeout(async function () {
          await loadReviews();
          closeModal();
          submitButton.disabled = false;
          submitButton.textContent = 'Envoyer mon avis';
        }, 1800);
      } catch (error) {
        console.error('Erreur envoi avis :', error);
        showError('Une erreur est survenue. Merci de réessayer.');
        submitButton.disabled = false;
        submitButton.textContent = 'Envoyer mon avis';
      }
    });

    var items = root.querySelectorAll('[data-reveal]');
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
      }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
      Array.prototype.forEach.call(items, function (n) { io.observe(n); });
    } else {
      Array.prototype.forEach.call(items, function (n) { n.classList.add('is-in'); });
    }

    loadReviews();
  }

  function initAll() {
    var list = document.querySelectorAll('.lr[data-lilova-reviews]');
    for (var i = 0; i < list.length; i++) init(list[i]);
  }
  initAll();
  document.addEventListener('shopify:section:load', initAll);
})();